<ng-container *ngIf="products.length > 0">
  <div class="container-fluid page-content">
    <section class="example-container mat-elevation-z8" tabindex="0">
      <table mat-table [dataSource]="products" class="example-table" outlined="appearance">
        <!-- Serial Number Column -->
        <ng-container matColumnDef="sNo">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let item; let i = index">{{ i + 1 }}</td>
        </ng-container>
        <!-- Item SKU Column -->
        <ng-container matColumnDef="itemSKU">
          <th mat-header-cell *matHeaderCellDef>Item SKU</th>
          <td mat-cell *matCellDef="let item">{{ item.item_SKU }}</td>
        </ng-container>
        <!-- Product Name Column -->
        <ng-container matColumnDef="productName">
          <th mat-header-cell *matHeaderCellDef>Product Name</th>
          <td mat-cell *matCellDef="let item">{{ item.item_Name }}</td>
        </ng-container>

        <!-- Product Image Column -->
        <ng-container matColumnDef="productImage">
          <th mat-header-cell *matHeaderCellDef>Product Image</th>
          <td mat-cell *matCellDef="let item"><img style="width: 120px;" [src]="item.image_Name" alt=""></td>
        </ng-container>

        <!-- Product CountryName -->
        <ng-container matColumnDef="countryName">
          <th mat-header-cell *matHeaderCellDef>Country Name</th>
          <td mat-cell *matCellDef="let item">{{ item.item_Country_Name }}</td>
        </ng-container>
        <!-- Description Column -->
        <!-- <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let item">{{ item.item_Description }}</td>
              </ng-container> -->



        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let item">{{ item.total_Costs_In_Local_Currency }} {{ item.currency_Code }}</td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action" stickyEnd>
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let item">
            <button mat-icon-button matTooltip="Delete item from cart" (click)="removeItem(item)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let item; columns: displayedColumns;"></tr>
      </table>
      <br>
    </section>
    <br>
    <!-- Additional Actions Row -->
    <div class="sticky-row d-flex justify-content-end mb-4 mt-4" >
      
      <button mat-raised-button color="warn" (click)="emptycart()">Empty Cart</button>
      <button mat-raised-button color="primary" (click)="view()">Shop More</button>
      <button mat-raised-button color="accent" (click)="checkoutDialog()">Checkout</button>
    </div>
  </div>
  <br>
</ng-container>



<ng-container *ngIf="products.length == 0">
  <div class="center">
    <img src="assets/images/emptyCart.jpg" alt="">
    <h4>Your cart is empty!</h4>
    <h6>Add item to it now</h6>
    <button mat-raised-button color="primary" (click)="view()">Shop Now</button>
  </div>

</ng-container>

<div *ngIf="showDialog" class="modal-dialog custom-modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title">Checkout</h6>
      <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <mat-radio-button (click)="radioButtonClick('excel')">Excel Upload</mat-radio-button>
      <mat-radio-button (click)="radioButtonClick('form')">Web Form</mat-radio-button>
    </div>
    <div class="modal-footer">
      <mat-icon class="notification">notification</mat-icon>
      <p>Please use excel upload option if you want to upload data for more than 5 users.
        If you want to upload data for 5 or less than 5 users then
        please use the web form option.</p>
    </div>
  </div>
</div>